/**
* @Author 22030124/xieyq
* @Date 2023-11-09 11:09:08
* @Description 用户选择器组件入口js
*/
// 引入用户选择器组件
import SelectUser from './select-user/index.vue'
// 人员选择弹窗组件
import SelectUserDialog from './select-user/dialog-select.vue'

// 用户选择
const CosmoSelectUser = {
  SelectUser,
  SelectUserDialog
}

export function install(Vue) {
  if (install.installed) return
  install.installed = true
  Object.keys(CosmoSelectUser).forEach(name => {
    Vue.component(name, CosmoSelectUser[name])
  })
}

// 注册安装方法
SelectUser.install = function (Vue) {
  Vue.component(SelectUser.name, SelectUser)
}

// 注册安装方法
SelectUserDialog.install = function (Vue) {
  Vue.component(SelectUserDialog.name, SelectUserDialog)
}

// 导出组件
export default CosmoSelectUser

export {
  SelectUser,
  SelectUserDialog
}
